export const ONE_MB = 1024 * 1024;
export const TWO_MB = ONE_MB * 2;
export const THREE_MB = ONE_MB * 3;

export const CLOUD_FUNCTIONS_BASE_URL = "https://us-central1-menuapp-b44a8.cloudfunctions.net";

// Regex
export const slugRegex = /^(?!-)(?!.*--)[a-z0-9]+(-[a-z0-9]+)*$/;
export const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
